import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
interface BookingStepProps {
  title: string;
  hint?: string;
  error?: string;
  children: React.ReactNode;
}

/** A titled block inside a wizard step, with an inline error banner. */
export function BookingStep({
  title,
  hint,
  error,
  children
}: BookingStepProps) {
  return <section data-id="element-84" data-mp="cdaducaut5r">
      <div className="mb-5" data-id="element-85" data-mp="cwlos7g2jat">
        <h3 className="font-display text-lg text-forest-700" data-id="element-86" data-mp="blh4q66d7in">{title}</h3>
        {hint && <p className="mt-1 text-[13px] text-muted" data-id="element-87" data-mp="4d6yanpqs7yn">{hint}</p>}
      </div>
      <AnimatePresence data-id="element-88" data-mp="9db7dsobm0eu">
        {error && <motion.p initial={{
        opacity: 0,
        y: -4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.18
      }} className="mb-5 flex items-center gap-2 rounded-sm bg-danger-50 px-4 py-3 text-[13px] text-danger-700" role="alert" data-id="element-89" data-mp="9dkyxkp0kfmn">
            <AlertCircleIcon size={15} className="shrink-0" aria-hidden="true" data-id="element-90" data-mp="lkkgtyc0h8g9" />
            {error}
          </motion.p>}
      </AnimatePresence>
      {children}
    </section>;
}